<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>
        <span class="breadcrumb m-0">
          <button class="btn btn-primary d-flex align-items-center" (click)="exportAll()">
            <span class="fas fa-file-excel"> </span> &nbsp;Export All to Excel
          </button>

        </span>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">

        <div class="card-body">
          <ng-template #template let-anchor>
            <span>{{ anchor.nativeElement.innerText }}</span>
          </ng-template>

          <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
            (mouseover)="showTooltip($event)">
            <kendo-grid [data]="meterDBgridData" [pageSize]="pageSize" [skip]="skip" [sortable]="true"
              [selectable]="selectableSettings" [pageable]="{
                                    buttonCount: buttonCount,
                                 info: info,
                                  type: type,
                                 pageSizes: pageSizes,
                                  previousNext: previousNext
                              }" [reorderable]="true" filterable="menu" [filter]="meterState.filter"
              [sort]="meterState.sort" [columnMenu]="{ filter: true }" (filterChange)="onMeterFilterChange($event)"
              (sortChange)="onSortChange($event)" [resizable]="true" scrollable="scrollable"
              (pageChange)="meterConfigPageChange($event)" (selectionChange)="selectionChanged($event)"
              (dataStateChange)="dataStateChange($event)">

              <ng-template kendoGridToolbarTemplate>
                <div class="search_icon">
                  <kendo-textbox [style.width.px]="250" [clearButton]="true" (valueChange)="onValueChange($event)"
                    (keyup.enter)="onSearchMeterAds()" [style.height.px]="35" [(ngModel)]="searchedValue"
                    placeholder="Search in all columns...">
                  </kendo-textbox>

                  <button class="btn btn-primary btn-md border-left-none" (click)="onMeterConfigFilter($event)">
                    <i class="fa fa-search"></i>
                  </button>
                </div>

                <kendo-grid-spacer></kendo-grid-spacer>
                <button class="btn btn-outline-primary btn-sm" *ngIf="role == Roles.SUPERADMIN || role == Roles.SUPERUSER || role == Roles.AGENTADMIN" (click)="bulkPaarove()">
                  Bulk Approve </button>
                <button class="btn btn-outline-primary btn-sm" *ngIf="role == Roles.SUPERADMIN || role == Roles.AGENTADMIN" (click)="createDBmeters(NewMeters)">
                  &nbsp; Create meter Database
                </button>
                <button class="btn btn-outline-primary btn-sm" *ngIf="role == Roles.SUPERADMIN || role == Roles.AGENTADMIN" (click)="openBulkUpload()">Meter Bulk
                  Upload </button>
<button
  class="btn btn-outline-primary btn-sm"
*ngIf="role == Roles.SUPERADMIN || role == Roles.AGENTADMIN"
  (click)="openAgentBulkUpload()"
>
  Agent Bulk Upload
</button>
                <div class="sm-device d-flex justify-content-between">

                  <button class="btn btn-outline-primary btn-sm" (click)="onMeterExport()">
                    <span class="fas fa-file-excel"> </span> &nbsp; Export to Excel
                  </button>
                </div>
              </ng-template>

              <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                class="no-tooltip"></kendo-grid-checkbox-column>

              <kendo-grid-column field="currentUtilityType" title="Utility" [width]="100">
                <ng-template kendoGridFilterMenuTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-menu [column]="column" [filter]="filter">
                  </kendo-grid-string-filter-menu>
                  <small style="color:brown">Search is case-sensitive.</small>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="meterSerialNo" title="Device Sr No" [width]="100">
                <ng-template kendoGridFilterMenuTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-menu [column]="column" [filter]="filter">
                  </kendo-grid-string-filter-menu>
                  <small style="color:brown">Search is case-sensitive.</small>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="deviceId" title="Device ID" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="macAddress" title="Mac Address" [width]="100"></kendo-grid-column>

              <kendo-grid-column field="isWiredCommunicationDevice" title="Is Wired" [width]="90" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.isWiredCommunicationDevice ? 'Yes' : 'No'}}
                </ng-template>

              </kendo-grid-column>
              <kendo-grid-column field="requestProject" title="Requested Project" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="approvalStatus" title="Status" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="bulkStatus" title="Bulk Approve Status" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="failedReason" title="Rejected Reason" [width]="100"></kendo-grid-column>
              <kendo-grid-command-column title="" [columnMenu]="false" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="d-flex">

                    <span *ngIf="!isEditRestricted(dataItem)" kendoTooltip title="Go To Meters Edit" (click)="goToEditMeters(dataItem)" class="me-3"
                      style="cursor: pointer;">
                      <i class="fas fa-edit text-primary"></i>
                    </span>
                      <span kendoTooltip title="Delete Meter"  class="me-3" *ngIf="dataItem?.approvalStatus==='NotStarted'"
                      style="cursor: pointer;" (click)="deleteMeterDB(dataItem)">
                      <i class="fas fa-trash-alt text-danger"></i>
                    </span>
                    <span kendoTooltip title="Approve"
                      *ngIf="dataItem?.approvalStatus === 'AgentMapped' || dataItem?.approvalStatus === 'AgentUnmapped'"
                      (click)="approveRejectConfirmation(dataItem,'approve','')" style="cursor: pointer;" class="me-3">
                      <i class="fas fa-check text-success"></i>
                    </span>

                    <span kendoTooltip title="Reject"
                      *ngIf="dataItem?.approvalStatus === 'AgentMapped' || dataItem?.approvalStatus === 'AgentUnmapped'"
                      (click)="approveRejectConfirmation(dataItem,'reject',invalidBillModal) " style="cursor: pointer;">
                      <!--  <i class="fas fa-redo text-danger"></i> -->
                      <i class="fas fa-times-circle  text-danger"></i>

                    </span>
                  </div>
                </ng-template>
              </kendo-grid-command-column>


            </kendo-grid>
          </div>

          <!--master download buttons start-->

          <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
            <kendo-grid [kendoGridBinding]="mySelectionMeter.length>0 ? mySelectionMeter:meterDBgridData.data" #pdfGrid>

              <kendo-grid-column field="currentUtilityType" title="Utility"></kendo-grid-column>
              <kendo-grid-column field="meterSerialNo" title="Device Sr No" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="deviceId" title="Device ID" [width]="100"></kendo-grid-column>
              
              <kendo-grid-column field="macAddress" title="Mac Address"></kendo-grid-column>
              <kendo-grid-column field="is_wired" title="Is Wired"></kendo-grid-column>
              <kendo-grid-column field="requestProject" title="Requested Project"></kendo-grid-column>
              <kendo-grid-column field="approvalStatus" title="Status"></kendo-grid-column>
              <kendo-grid-column field="bulkStatus" title="Bulk Approve Status" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="failedReason" title="Rejected Reason" [width]="100"></kendo-grid-column>
              <kendo-grid-excel fileName="Meters Database.xlsx"></kendo-grid-excel>
            </kendo-grid>
          </div>


        </div>
      </div>
    </div>
  </div>



  <ng-template #NewMeters>

    <div class="modal-lg ">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">Create Meters Database</h5>
          <!--   @if(billChargeId) { <h5 class="modal-title">Edit Charge</h5>}
          @else {<h5 class="modal-title">Add Charges</h5>} -->
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modelRef_1.hide()"></button>
        </div>
        <div class="modal-body">
          <form class="form-horizontal" [formGroup]="createUMDForm">

            <div class="mb-3">
              <label>Utility <span class="required">*</span></label>
              <ng-select [items]="meterUtilities" bindLabel="name" id="utilityMasterId" name="utilityMasterId"
                bindValue="id" formControlName="utilityMasterId" [multiple]="false" [placeholder]="'Select...'"
                (change)="changeUtility($event)"></ng-select>
              @if(submitted && createUMDForm.controls['utilityMasterId'].errors) {
              <div class="invalid-feedback">
                @if(createUMDForm.controls['utilityMasterId'].errors['required']) {
                <div>{{Umd_Validations.utilityMasterId.required}}</div>}
              </div>}
            </div>
            <div class="mb-3">
              <label>Mac Address<span class="required">*</span></label>
              <input type="text" formControlName="macAddress" id="macAddress" class="form-control"
                placeholder="Enter Mac Address" />
              @if(submitted && createUMDForm.controls['macAddress'].errors) {
              <div class="invalid-feedback">

                <!-- Required -->
                @if(createUMDForm.controls['macAddress'].errors['required']) {
                <div>{{ Umd_Validations.macAddress.required }}</div>
                }

                <!-- Pattern (different msg for wired / not wired) -->
                @if(createUMDForm.controls['macAddress'].errors['pattern'] && !this.iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.pattern }}</div>
                }
                @if(createUMDForm.controls['macAddress'].errors['pattern'] && this.iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.isWiredPattern }}</div>
                }

                <!--Is wired :true  start  (min and max same Exactly 7 char)-->

                @if(createUMDForm.controls['macAddress'].errors['minlength'] && iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.Ismwiredmax }}</div>
                }
                @if(createUMDForm.controls['macAddress'].errors['maxlength'] && iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.Ismwiredmax }}</div>
                }

                <!-- end  -->

                <!--Is wired :false  start  (min and max :Exactly 16)-->

                @if(createUMDForm.controls['macAddress'].errors['maxlength'] && !iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.maxlength }}</div>
                }
                @if(createUMDForm.controls['macAddress'].errors['minlength'] && !iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.maxlength }}</div>
                }
                <!-- end  -->



                <!-- Minlength -->
                <!-- @if(createUMDForm.controls['macAddress'].errors['minlength'] && this.iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.minlength }}</div>
                }

                @if(createUMDForm.controls['macAddress'].errors['minlength'] && !this.iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.maxlength }}</div>
                } -->

                <!-- Maxlength (different msg for wired / not wired) -->

                <!-- 
                @if(createUMDForm.controls['macAddress'].errors['maxlength'] && !this.iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.maxlength }}</div>
                }
                @if(createUMDForm.controls['macAddress'].errors['maxlength'] && this.iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.Ismwiredmax }}</div>
                } -->

              </div>
              }
            </div>
            <div class="mb-3">
              <label>Device Sr No <span class="required">*</span></label>
              <input type="text" formControlName="meterSerialNo" id="meterSerialNo" class="form-control"
                placeholder="Enter Meter Serial Number" />
              @if(submitted && createUMDForm.controls['meterSerialNo'].errors) {
              <div class="invalid-feedback">
                @if(createUMDForm.controls['meterSerialNo'].errors['required']) {
                <div>{{Umd_Validations.meterSerialNo.required}}</div>}

                @if(createUMDForm.controls['meterSerialNo'].errors['pattern'] && this.iswirdeCommunication){
                <div>{{Umd_Validations.meterSerialNo.pattern}}</div>}

                @if(createUMDForm.controls['meterSerialNo'].errors['pattern'] && !this.iswirdeCommunication){
                <div>{{Umd_Validations.meterSerialNo.isNotWiredPattern}}</div>}

                <!--  @if(createUMDForm.controls['meterSerialNo'].errors['maxlength'] && !this.iswirdeCommunication){
                <div>{{Umd_Validations.macAddress.maxlength}}</div>}

                @if(createUMDForm.controls['meterSerialNo'].errors['minlength']) {
                <div>{{ Umd_Validations.macAddress.minlength }}</div>
                } -->


                <!-- @if(createUMDForm.controls['meterSerialNo'].errors['maxlength'] && this.iswirdeCommunication) {
                <div>{{ Umd_Validations.macAddress.Ismwiredmax }}</div>
                } -->

                <!--Is wired :true  start  (min:7 and max:16 char)-->

                @if(createUMDForm.controls['meterSerialNo'].errors['minlength'] && !this.iswirdeCommunication) {
                <div>{{ Umd_Validations.meterSerialNo.minlength }}</div>
                }
                @if(createUMDForm.controls['meterSerialNo'].errors['maxlength'] && !this.iswirdeCommunication) {
                <div>{{ Umd_Validations.meterSerialNo.maxlength }}</div>
                }

                <!-- end -->

                <!--Is wired :false  start  (min and max :Exactly 7)-->
                @if(createUMDForm.controls['meterSerialNo'].errors['maxlength'] && this.iswirdeCommunication) {
                <div>{{ Umd_Validations.meterSerialNo.Ismwiredmax }}</div>
                }
                @if(createUMDForm.controls['meterSerialNo'].errors['minlength'] && this.iswirdeCommunication){
                <div>{{Umd_Validations.meterSerialNo.Ismwiredmax}}</div>}


              </div>}
            </div>

            <div class="mb-3" *ngIf="selectedutlity?.name =='Electricity' || selectedutlity?.name =='TriSource'">
              <input class="form-check-input" type="checkbox" (change)="onCheckboxChange($event)"
                formControlName="isWiredCommunicationDevice" id="formCheck1">&nbsp;
              <label class="form-check-label" for="formCheck1">Wired Communication Device</label>

            </div>

            <div class="mb-3" *ngIf="iswirdeCommunication">
              <label>Device id <span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="deviceId" id="deviceId" name="deviceId"
                placeholder="Enter deviceId Number">
              @if(submitted && createUMDForm.controls['deviceId'].errors) {
              <div class="invalid-feedback">
                @if(createUMDForm.controls['deviceId'].errors['required']) {
                <div>{{Umd_Validations.deviceId.required}}</div>}
                @if(createUMDForm.controls['deviceId'].errors['pattern']){
                <div>{{Umd_Validations.deviceId.pattern}}</div>}
                @if(createUMDForm.controls['deviceId'].errors['maxlength']){
                <div>{{Umd_Validations.deviceId.maxlength}}</div>}
              </div>}
            </div>
            <div class="mb-3">
              <label for="">Supplier <span class="required">*</span></label>
              <ng-select [items]="waterTypeItems" bindLabel="name" bindValue="id" [placeholder]="'Select...'" [multiple]="false"
                formControlName="supplierId" [clearable]="!!createUMDForm.get('supplierId')?.value"></ng-select>
              <div *ngIf="submitted && createUMDForm.controls['supplierId'].errors" class="invalid-feedback">
                <div *ngIf="createUMDForm.controls['supplierId'].errors['required']">
                  {{ Umd_Validations.supplierId.required }}
                </div>
              </div>
            </div>
          </form>

        </div>
        <div class="modal-footer">

          <button type="button" class="btn btn-primary waves-effect waves-light"
            (click)="saveMeterDataBase()">Save</button>
        </div>
      </div>
    </div>
  </ng-template>



  <!-- Invalid Bill modal -->
  <ng-template #invalidBillModal>

    <div class="">
      <div class="">
        <div class="modal-header ">
          <h5 class="modal-title">Rejected Reason</h5>
          <button type="button" class="btn-close text-white" data-bs-dismiss="modal" aria-label="Close"
            (click)="modalRefReasons?.hide()"></button>
        </div>
        <div class="modal-body">

          <div class="mb-3">
            <label> Reason for Reject <span class="required">*</span></label>
            <textarea [placeholder]="'Enter your reason here'" [(ngModel)]="reason" (ngModelChange)="validateReason()"
              class="form-control" rows="5"></textarea>
            <!--  <span *ngIf="!reason"></span> -->
            <div class="text-danger" *ngIf="reasonError">
              Reason cannot be empty or just spaces.
            </div>

          </div>

        </div>
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-secondary waves-effect" data-bs-dismiss="modal" >Close</button> -->
          <button type="button" class="btn btn-primary waves-effect waves-light" (click)="saveReject()"
            [disabled]="!reason">Submit</button>
        </div>
      </div><!-- /.modal -->
    </div>
  </ng-template>
  <!-- Invalid Bill modal End  -->
</div>
